import { useContext, useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import { UserContext } from "../userContext"
import { fetchResource } from "../../methods/fetchResource"
import ExemptionCheckbox from "./components/exemptionCheckbox"
import ExemptionCheckboxHidden from "./components/exemptionCheckboxHidden"
import Spinner, { ToggleSpinner } from "../components/spinner"
import { generateErrorMessage } from "../../methods/generateErrorMessage"

export default function Exemptions() {
	const baseURL = "https://srcpa.gov"
	const [message, setMessage] = useState("")
	const [exemptionsList, setExemptionsList] = useState([])
	const [formElements, setFormElements] = useState([])
	const navigate = useNavigate()
	const userContext = useContext(UserContext)
	const hxInputElement = useRef(null)
	const totalAndPermanent = ["06", "25", "14", "13", "21", "99", "96", "95"]
	let knockouts = useRef({
		2: [],
		3: [],
		18: []
	})

	useEffect(() => {
		async function fetchData() {
			let exemptionsListReference = await fetchResource(`/api/existingExemptions?parcelID=${userContext.parcelID}`)

			if (!exemptionsListReference.success) {
				setMessage(generateErrorMessage(exemptionsListReference.status))
				//document.getElementById("exemptionsMessage").scrollIntoView()
				return
			}

			let exemptionsListArray = []

			exemptionsListReference.result.rows.forEach((exemption) => {
				exemptionsListArray.push(exemption.exemption_code)
			})

			setExemptionsList(exemptionsListArray)

			let formElementsToUse = await fetchResource("/api/formElements")

			if (!formElementsToUse.success) {
				setMessage(generateErrorMessage(formElementsToUse.status))
				//document.getElementById("exemptionsMessage").scrollIntoView()
				return
			}

			let sortedElements = formElementsToUse.result.sort((a, b) => a.display_order - b.display_order)

			setFormElements(sortedElements)
		}

		fetchData()
	}, [userContext.parcelID])


	function onExemptionChange(event) {
		let exemptionsListCheckboxes = document.getElementsByName("ExemptionsList")

		if (hxInputElement.current === null) {
			for (let i = 0; i < exemptionsListCheckboxes.length; i++) {
				if (formElements[exemptionsListCheckboxes[i].value].cama_code === "HX") {
					hxInputElement.current = exemptionsListCheckboxes[i]
					break
				}
			}
		}

		document.getElementById(event.target.value).style.display = event.target.checked ? "block" : "none"

		document.getElementsByName("ExemptionsList").forEach((element) => {
			if (element === event.target) {
				return
			}

			if (formElements[event.target.value].cama_code === formElements[element.value].cama_code) {
				toggleElementDisplay(element)
				return
			}

			//T&P Knockouts
			if (totalAndPermanent.includes(formElements[event.target.value].cama_code) && totalAndPermanent.includes(formElements[element.value].cama_code)) {
				toggleElementDisplay(element)
				return
			}

			if (element.attributes.alwayshidden.value === "true") {
				return
			}

			element.style.display = "inline-block"
		})

		//New Knockout System
		handleKnockout(event, 1, 3, false)
		handleKnockout(event, 2, 3, false)
		handleKnockout(event, 3, 2, false)
		handleKnockout(event, 17, 18, true)

		//This section is to enforce homestead being selected if parcel doesn't have hx and user selects something requiring hx
		if (userContext.parcelHasHxCode || userContext.bypassResidencyDueToApplication) {
			return
		}

		if (hxInputElement.current.checked) {
			return
		}

		for (let i = 0; i < exemptionsListCheckboxes.length; i++) {
			if (exemptionsListCheckboxes[i] === hxInputElement.current.checked) {
				continue
			}

			if (exemptionsListCheckboxes[i].checked && formElements[exemptionsListCheckboxes[i].value].hx_related) {
				hxInputElement.current.checked = "true"
				break
			}
		}
	}

	function handleKnockout(event, id, target, override) {
		if (event.target.id !== `exemption|${id}`) {
			return
		}

		if (document.getElementById(`exemption|${target}`) === null) {
			return
		}

		if (override) {
			if (document.getElementById(`exemption|${target}`).checked) {
				return
			}
		}

		if (event.target.checked) {
			if (!knockouts.current[target].includes(id)) {
				knockouts.current[target].push(id)

				document.getElementById(`exemption|${target}`).parentElement.style.display = "none"
				document.getElementById(`exemption|${target}`).checked = false
			}

			return
		}

		knockouts.current[target] = knockouts.current[target].filter(x => x !== id)

		if (knockouts.current[target].length === 0) {
			document.getElementById(`exemption|${target}`).parentElement.style.display = "block"
		}
	}

	function toggleElementDisplay(element) {
		if (element.attributes.alwayshidden.value === "true") {
			return
		}

		actuallyToggleElement(element.parentElement)
	}

	function actuallyToggleElement(element) {
		element.style.display = element.style.display === "none" ? "block" : "none"
	}

	async function onSubmitButtonClicked(event) {
		event.preventDefault()
		setProcessingVisuals()

		let selectedExemptionCodes = []

		document.getElementsByName("ExemptionsList").forEach((element) => {
			if (element.checked) {
				selectedExemptionCodes.push(formElements[element.value].exemption_id)
			}
		})

		if (selectedExemptionCodes.length === 0) {
			setMessageAndHandleThings("Please select one or more exemptions you would like to apply for")
			return
		}

		if (!window.confirm("Please have digital copies of the documents listed in the Key Requirements for the exemptions you have selected.\n\nIf you aren't ready, please take a moment to gather what you may need, and then continue from here.")) {
			setMessageAndHandleThings("")
			return
		}

		userContext.selectedExemptions = selectedExemptionCodes

		//Homestead or Deployed Military, HX or AM
		if (userContext.selectedExemptions.includes(1) || userContext.selectedExemptions.includes(19)) {
			navigate("/addressChangeForm")
			return
		}

		let docusignURL = await fetchResource("/api/docusign", {
			parcelID: userContext.parcelID,
			email: userContext.email,
			name: userContext.name,
			exemptions: userContext.selectedExemptions
		})

		if (!docusignURL.success) {
			setMessageAndHandleThings(docusignURL.message)
			return
		}

		alert(docusignURL.message)

		window.open(docusignURL.result.url, "_self")
	}

	function setProcessingVisuals() {
		document.getElementById("submitButton").disabled = "true"
		document.getElementById("submitButton").style.display = "none"
		document.getElementById("processingNote").style.display = "inline-block"

		ToggleSpinner("spinner")

		setMessage("")
		//document.getElementById("spinner").scrollIntoView()
	}

	function setMessageAndHandleThings(message) {
		document.getElementById("submitButton").disabled = ""
		document.getElementById("submitButton").style.display = "inline-block"
		document.getElementById("processingNote").style.display = "none"

		ToggleSpinner("spinner")

		setMessage(message)
		//document.getElementById("exemptionsMessage").scrollIntoView()
	}

	return (
		<div id="exemptions-portal--exemptions" className="container">
			<div className="row">
				<div className="col-12">
					<h1 className="h1-style">Additional Exemptions Page</h1>
					<div className="bg-navy text-light p-3 rounded mb-3">
						<div className="bg-navy-dark p-3 rounded mb-3">
							<p>
								Select one or more of the following exemptions for which you would like to apply.
							</p>
							<p className="bold-text">
								You can read more about the exemptions from
								{" "}
								<a
									href={`${baseURL}/exemptions-information/`}
									target="_blank"
									rel="noreferrer noopener"
									className="text-warning"
								>
									this link.
								</a>
							</p>
						</div>
						<div className="bg-navy-dark p-3 rounded mb-3">
							<p>
								Note: Some selections will disable others due to conflicting situations or overlapping end results.
							</p>
							<p>
								If you still wish to apply for an exemption that is not shown, please visit us at our office.
							</p>
						</div>
						<div className="bg-navy-dark p-3 rounded mb-3">
							<ul className="px-0 mb-0 list-unstyled">
								{
									formElements.map((element, index) => {
										/*
											If this is not their homestead, and they indicated it is not, then
											we only want to show the non-HX related exemptions. Otherwise, we
											want to show all.

											What gets displayed is filtered based on if they already have the
											exemption regardless of the above conditions.
										*/
										if (exemptionsList.includes(element.cama_code)) {
											return (<ExemptionCheckboxHidden key={index} element={element} index={index} defaultChecked={false} />)
										}

										if (!userContext.parcelHasHxCode && !userContext.user_is_homestead && !userContext.bypassResidencyDueToApplication) {
											if (element.hx_related) {
												return (<ExemptionCheckboxHidden key={index} element={element} index={index} defaultChecked={false} />)
											}

											return (<ExemptionCheckbox key={index} element={element} index={index} defaultChecked={false} onExemptionChange={onExemptionChange} />)
										}

										//hiding 21 (T&P veteran, requires wheelchair) due to it being noted that it is tracked under 13
										if (element.cama_code === "21") {
											return (<ExemptionCheckboxHidden key={index} element={element} index={index} defaultChecked={false} />)
										}

										//Force HX to be selected at first if they don't have hx already but could be applying for it now
										if (element.cama_code === "HX") {
											if (userContext.bypassResidencyDueToApplication) {
												return (<ExemptionCheckboxHidden key={index} element={element} index={index} defaultChecked={false} />)
											}

											return (<ExemptionCheckbox key={index} element={element} index={index} defaultChecked={true} onExemptionChange={onExemptionChange} />)
										}

										return (<ExemptionCheckbox key={index} element={element} index={index} defaultChecked={false} onExemptionChange={onExemptionChange} />)
									})
								}
							</ul>
						</div>
						<h2 id="processingNote" className="StartHidden">
							Please wait, this may take a few moments.
						</h2>
						<Spinner id="spinner" />
						<button
							type="button"
							id="submitButton"
							onClick={onSubmitButtonClicked}
							className="btn btn-warning"
						>
							Submit
						</button>
						<h2 id="exemptionsMessage" className={`mt-3 bg-danger text-light p-3 rounded ${message === "" ? "d-none" : ""}`}>
							{message}
						</h2>
					</div>
				</div>
			</div>
		</div>
	)
}